import React from 'react'

import PT from 'prop-types'
import CountUp from 'react-countup'

import { colors } from '../../../../../../theme'

const StatCountUp = ({ data = 0, dataTestId, prefix, style, suffix = undefined, title }) => (
  <div style={style}>
    <div
      style={{
        color: colors.gray2,
        fontSize: 14,
        marginBottom: 3,
      }}
    >
      {title}
    </div>
    <div
      data-testid={dataTestId}
      className="count-up-number"
      style={{ color: 'rgba(0, 0, 0, 0.8)', fontSize: 24 }}
    >
      <CountUp prefix={prefix} separator="," start={0} end={data} suffix={suffix} />
    </div>
  </div>
)

StatCountUp.propTypes = {
  data: PT.number,
  dataTestId: PT.string,
  prefix: PT.string,
  style: PT.object,
  title: PT.string,
}

export default StatCountUp
